<template>
  <div class="home-page cg-page" style="padding-top: 0;">
    <div class="login-content">
      <div class="" style="text-align: center">
        <img style="width: 35%" src="../../static/images/logo.png">
      </div>
      <div >
        <div class="">
          <div class="home-prize" style="padding-top:30px;">

          </div>

          <div class="span fs33 ac mt30 app-en" style="width:50%;margin: 0 auto;color: white">
            စာရင်းသွင်းမှု မအောင်မြင်ပါ။
          </div>

          <div class="ac mt50">
            <button class="btn btn-blue btn-green0 mt50" style="min-width: 350px;height: 120px;font-size: 40px">
              <span @click="goLogin">စာရင်းသွင်းပါ။</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  components:{

  },
  data() {
    return {
      msg:'',
    }
  },
  created(){
    let msg = this.$route.query.msg
    if(msg){
      this.msg = msg
    }
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
  },
  methods: {
    goLogin(){
      this.$router.push({path:'/'});
    },
  }
}
</script>
<style scoped>
.drop-down-content{z-index:9;background:none;}
.landing-page{padding-bottom:60px;}
</style>



// WEBPACK FOOTER //
// src/page/errors.vue